import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import ObjectViewer from '../Common/ObjectViewer';
import { apiAction, generalSet } from '../../store/generalSlice';
import CreateCampaign from './CreateCampaign';

const AccountDashboard = () => {
  const dispatch = useDispatch();
  const { account_id } = useParams();
  const { allAccountData, campaigns, adVolume, updatePagesAdVolume } = useSelector((state) => state.general);

  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showAdVolume, setShowAdVolume] = useState(false);
  console.log({ allAccountData, campaigns, adVolume, updatePagesAdVolume });

  useEffect(() => {
    dispatch(
      apiAction({ reduxField: 'allAccountData', route: 'accountDashboard/getAllAccountData', accountId: account_id })
    );
  }, [dispatch, account_id]);

  if (allAccountData?.accountId !== account_id) {
    dispatch(generalSet({ reduxField: 'allAccountData', value: null }));
  }

  if (!allAccountData?.accountId) {
    return <Spinner />;
  }

  const campaignsColumns = [
    {
      field: 'id',
      headerName: 'id',
      width: 200,
      renderCell: (params) => {
        return (
          <a href={`/campaign/${account_id}/${params.row.id}`} target='_blank' rel='noreferrer'>
            {params.value}
          </a>
        );
      },
    },
    {
      field: 'name',
      headerName: 'name',
      width: 450,
    },
    {
      field: 'status',
      headerName: 'status',
      width: 100,
    },
    {
      field: 'objective',
      headerName: 'objective',
      width: 200,
    },
    {
      field: 'created_time',
      headerName: 'created_time',
      width: 200,
    },
  ];

  return (
    <div className='mt-4 mb-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        <h3>Ad Account Dashboard</h3>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
        <h5>
          Account Data from Facebook <span className='text-primary'>getAdAccountData(accountId, token)</span>
        </h5>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        {allAccountData?.accountData ? (
          <ObjectViewer data={allAccountData.accountData} />
        ) : (
          <span className='text-danger'>Can't Fetch AccountData</span>
        )}
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
        <h5>
          Account DB{' '}
          <span className='text-primary'>
            {'pgQuery(`SELECT * FROM ad_accounts WHERE traffic_channel_id = accountId`)'}
          </span>
        </h5>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        {allAccountData?.accountFromDb ? (
          <ObjectViewer data={allAccountData.accountFromDb} />
        ) : (
          <span className='text-danger'>Can't Fetch AccountData</span>
        )}
      </div>
      <div className='row d-flex justify-content-center p-3 border'>
        {showAdVolume ? (
          <>
            {Array.isArray(adVolume?.data) && adVolume?.data[0] && adVolume?.data[0]?.ads_running_or_in_review_count ? (
              <>
                <span>
                  Number of ads running:{' '}
                  <span className='text-primary'>{adVolume.data[0].ads_running_or_in_review_count}</span>
                </span>
              </>
            ) : (
              <Spinner />
            )}
          </>
        ) : (
          <button
            className='btn btn-outline-primary'
            onClick={() => {
              setShowAdVolume(true);
              dispatch(
                apiAction({
                  reduxField: 'adVolume',
                  route: 'accountDashboard/getAdVolume',
                  accountId: account_id,
                })
              );
            }}
          >
            Show Ad Volume
          </button>
        )}
      </div>
      <>
        <button
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'updatePagesAdVolume',
                route: 'accountDashboard/updatePageAdVolumeByAccountId',
                accountId: account_id,
              })
            );
          }}
        >
          Update Pages Ad Volume
        </button>
      </>
      <>
        <CreateCampaign accountId={account_id} />
      </>
      <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
        <h5>
          Campaigns from Facebook {Array.isArray(campaigns) ? `(${campaigns.length})` : null}{' '}
          <span className='text-primary'>getAllCampaignsByAccountId(accountId, token)</span>
        </h5>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        <>
          {showCampaigns ? (
            <div data-aos='fade-up' data-aos-delay='200'>
              {Array.isArray(campaigns) ? (
                <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
                  <Box style={{ height: 600, width: '100%' }}>
                    <DataGrid
                      rows={campaigns}
                      columns={campaignsColumns}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      //   checkboxSelection
                      disableSelectionOnClick
                    />
                  </Box>
                </div>
              ) : (
                <Spinner />
              )}
            </div>
          ) : (
            <button
              className='btn btn-outline-primary mt-2 mb-4'
              onClick={() => {
                dispatch(
                  apiAction({
                    reduxField: 'campaigns',
                    route: 'accountDashboard/getAllCampaignsByAccountId',
                    accountId: account_id,
                    fields: ['id', 'name', 'status', 'objective', 'created_time'],
                  })
                );
                setShowCampaigns(true);
              }}
            >
              Show Campaigns
            </button>
          )}
        </>
      </div>
    </div>
  );
};

export default AccountDashboard;
